import Vue from 'vue'
import Router from 'vue-router'

import Accueil from '@/components/Accueil'
import MentionsLegales from '@/components/MentionsLegales'
import PolitiqueConfidentialite from '@/components/PolitiqueConfidentialite'
import Contact from '@/components/Contact'
import Actualites from '@/components/Actualites'
import Actualite from '@/components/Actualite'
import Histoire from '@/components/Histoire'
import Vins from '@/components/Vins'
import Vin from '@/components/Vin'


Vue.use(Router)

export default new Router({
  routes: [
    { path: '/',                              name: 'Accueil',                        component: Accueil } ,
    { path: '/contact',                       name: 'Contact',                        component: Contact } ,
    { path: '/vins',                          name: 'Vins',                           component: Vins } ,
    { path: '/vin/:type/:cat',                name: 'Vin',                            component: Vin } ,
    { path: '/actualites',                    name: 'Actualites',                     component: Actualites } ,
    { path: '/histoire',                      name: 'Histoire',                       component: Histoire } ,
    { path: '/actualite/:slug',               name: 'Actualite',                      component: Actualite } ,
    { path: '/mentions-legales',              name: 'MentionsLegales',                component: MentionsLegales } ,
    { path: '/politique-confidentialite',     name: 'PolitiqueConfidentialite',       component: PolitiqueConfidentialite } ,
    
  ]
})





// WEBPACK FOOTER //
// ./src/router/index.js